/**
 * shadcn/ui themes off a `.dark` class rather than the `prefers-color-scheme` media query, which
 * is what leaves room for a manual toggle later. Until there is one, the OS decides.
 */
export function startThemeSync(): void {
  const media = window.matchMedia('(prefers-color-scheme: dark)')

  const apply = (dark: boolean) => document.documentElement.classList.toggle('dark', dark)

  apply(media.matches)
  media.addEventListener('change', (event) => apply(event.matches))
}
